import {BranchName, NavList} from '@primer/react'
import {PlusIcon, GitBranchIcon} from '@primer/octicons-react'
import type {StackData} from '../page-data/payloads/header'
import {StateIcon} from './StateIcon'
import styles from './StackState.module.css'

type StackOverlayProps = {
  pullRequestNumber: number
  stack: StackData
  baseBranchText: string
  addToStackURL?: string
  tabSuffix?: string
  showStackMutationButtons?: boolean
}

export function StackOverlay({
  pullRequestNumber,
  stack,
  baseBranchText,
  addToStackURL,
  tabSuffix = '',
  showStackMutationButtons = true,
}: StackOverlayProps) {
  const {pulls} = stack

  return (
    <NavList className={styles.stackNavList}>
      {showStackMutationButtons && addToStackURL && (
        <NavList.Item href={addToStackURL}>
          <NavList.LeadingVisual>
            <PlusIcon />
          </NavList.LeadingVisual>
          Add to stack
        </NavList.Item>
      )}
      {pulls.map(stackedPR => {
        const isCurrent = stackedPR.number === pullRequestNumber
        return (
          <NavList.Item
            key={`stacked-pr-${stackedPR.number}`}
            href={`${stackedPR.url}${tabSuffix}`}
            aria-current={isCurrent ? 'page' : undefined}
          >
            <NavList.LeadingVisual>
              <StateIcon state={stackedPR.state} />
            </NavList.LeadingVisual>
            <div className={styles.prItemContent}>
              <span className={styles.prTitle}>{stackedPR.title}</span>
              <span className={styles.prMeta}>
                <span className={'text-normal'}>#{stackedPR.number}</span>
                <span className={styles.prBranch}>
                  <BranchName as="span" className={styles.prBranchName}>
                    {stackedPR.headBranch}
                  </BranchName>
                </span>
              </span>
            </div>
          </NavList.Item>
        )
      })}
      <li className={styles.branchItem}>
        <span className={styles.branchItemContent}>
          <GitBranchIcon className="fgColor-muted" />
          <BranchName as="span">{baseBranchText}</BranchName>
        </span>
      </li>
    </NavList>
  )
}
